export default "__VITE_ASSET__dec1ec4d__"